var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeOrangeBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1903.94 387.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0+0L0+138.22C36.6341+224.928+102.953+299.37+186.564+342.784C243.503+372.205+307.698+386.969+371.878+387.128C406.222+387.222+440.464+383.071+473.785+374.753C579.214+348.335+658.732+267.599+765.663+241.158C806.852+231+847.869+227.833+890.227+229.752C1107+239.711+1325.75+382.46+1543.36+340.191C1640.87+321.216+1814.84+201.203+1903.95+67.6256L1903.95+0L0+0Z",
    opacity: 1,
    fill: "#e76606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeOrangeBig);
export default __webpack_public_path__ + "static/media/shape_orange_big.5b613ae1f2ea96050aecd685a9e7dd83.svg";
export { ForwardRef as ReactComponent };